import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'
import { useFeatureFlags } from '../hooks/useFeatureFlags'
import RestrictedModeRoutes from './RestrictedModeRoutes'
import ProtectedRoutes from './ProtectedRoutes'
import { IUserDetail } from '../types/user'

interface Props {
  user: IUserDetail | null
  loggedIn: boolean
  haveRight: boolean
  checkLoader: boolean
  projectAdminRight: string[]
}

/**
 * Top-level router that waits for feature flags to load,
 * then renders either RestrictedModeRoutes or ProtectedRoutes (regular mode).
 * This eliminates race conditions by ensuring flags are loaded before any routing decisions.
 */
const AppRouter: React.FC<Props> = (props) => {
  const { featureFlags, loading: flagsLoading } = useFeatureFlags()

  // Wait for feature flags to load before rendering any routes
  if (flagsLoading) {
    return (
      <Dimmer active inverted>
        <Loader size='big'>Loading...</Loader>
      </Dimmer>
    )
  }

  // Render restricted mode routes if enabled
  if (featureFlags && featureFlags.enable_restricted_access_mode) {
    return <RestrictedModeRoutes {...props} />
  }

  // Render regular mode routes
  return <ProtectedRoutes {...props} />
}

export default AppRouter
